// extracted by mini-css-extract-plugin
export default {"btn":"ButtonTwo_btn__LjhHi"};